(function() {
var BriefingWizardForm,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

BriefingWizardForm = (function() {
  function BriefingWizardForm(form_containter, form_selector) {
    this.submit_form = bind(this.submit_form, this);
    this.show_step = bind(this.show_step, this);
    var i, len, ref, step, step_element;
    this.form_selector = form_selector;
    this.form_containter = form_containter;
    this.step_elements = this.form_containter.find("[data-wizard-step]");
    this.num_steps = this.step_elements.length;
    this.steps = {};
    ref = this.step_elements;
    for (i = 0, len = ref.length; i < len; i++) {
      step_element = ref[i];
      step = $(step_element);
      this.steps[step.data("wizard-index")] = step;
    }
    $(document).on("click", "[data-wizard-accept]", (function(_this) {
      return function(e) {
        return _this.accept_clicked(e);
      };
    })(this));
    this.current_index = 1;
    this.show_step();
  }

  BriefingWizardForm.prototype.accept_clicked = function(e) {
    var $button, $wizard_step, briefing_id;
    e.preventDefault();
    $button = $(e.target);
    briefing_id = $button.data("wizard-accept");
    $wizard_step = $button.closest("[data-wizard-step]");
    $button.removeClass("btn-primary").addClass("btn-success");
    return this.next_step($wizard_step);
  };

  BriefingWizardForm.prototype.next_step = function(current_wizard_step) {
    var _wizard_index;
    if (this.current_index < this.num_steps) {
      this.current_index += 1;
    }
    _wizard_index = current_wizard_step.data("wizard-index");
    if (_wizard_index === this.num_steps) {
      return this.submit_form();
    } else if (this.current_index <= this.num_steps) {
      return this.show_step();
    }
  };

  BriefingWizardForm.prototype.show_step = function() {
    var _current_step, _top_offset, height;
    _current_step = this.steps[this.current_index];
    _current_step.show();
    _top_offset = _current_step.offset().top;
    height = this.form_containter[0].scrollHeight;
    return $('html, body').animate({
      scrollTop: _top_offset
    }, 'fast');
  };

  BriefingWizardForm.prototype.submit_form = function() {
    return this.form_containter.find("form").submit();
  };

  return BriefingWizardForm;

})();

jQuery(function() {
  var $briefing_wizard_form_el;
  $briefing_wizard_form_el = $("#briefing_wizard_form");
  if ($briefing_wizard_form_el.length > 0) {
    return this.briefing_wizard_form = new BriefingWizardForm($briefing_wizard_form_el, "#briefing_wizard_form");
  }
});

}).call(window);
